import { PAGE_DEFAULT, ROW_DEFAULT } from "constants/global";

export const EMPTY_DATA_SEARCH_CONTRACT_COMPLAINTS = {
    name_contract: '',
    code_complaint: '',
    row: ROW_DEFAULT,
    page: PAGE_DEFAULT,
}
